<template>
  <div class="tachyon-container">
    <div class="big-data-scheme-wrapper">
      <v-lazy-image v-if="window.width > 1199" class="big-data-scheme" src="/static/img/features_page/big_data_scheme.png" src-placeholder="/static/img/placeholder.jpg" alt="big data scheme"/>
      <v-lazy-image v-if="window.width > 991 && window.width < 1200" class="big-data-scheme" src="/static/img/features_page/big_data_scheme_1200.png" src-placeholder="/static/img/placeholder.jpg" alt="big data scheme"/>
      <v-lazy-image v-if="window.width > 575 && window.width < 992" class="big-data-scheme" src="/static/img/features_page/big_data_scheme_575.png" src-placeholder="/static/img/placeholder.jpg" alt="big data scheme"/>
      <v-lazy-image v-if="window.width < 576" class="big-data-scheme" src="/static/img/features_page/big_data_scheme_320.png" src-placeholder="/static/img/placeholder.jpg" alt="big data scheme"/>
      <div>
        <hotspot class="mobile-hotspot"></hotspot>
        <tooltip class="collect-tooltip mobile-tooltip">Mobile Tracking</tooltip>
      </div>
      <div>
        <hotspot class="iot-hotspot"></hotspot>
        <tooltip class="collect-tooltip iot-tooltip">IOT Connectors</tooltip>
      </div>
      <div>
        <hotspot class="tracking-hotspot"></hotspot>
        <tooltip class="collect-tooltip tracking-tooltip">Tracking and<br>Digital Analytics</tooltip>
      </div>
      <div>
        <hotspot class="any-format-hotspot"></hotspot>
        <tooltip class="collect-tooltip any-format-tooltip">Any Format Batch<br>Data Ingestions</tooltip>
      </div>
      <div>
        <hotspot class="sensitize-hotspot"></hotspot>
        <tooltip class="white-tooltip sensitize-tooltip">Sensitize All Data For<br>Single Source of Truth</tooltip>
      </div>
      <div>
        <hotspot class="scheme-hotspot"></hotspot>
        <tooltip class="white-tooltip scheme-tooltip">Scheme Creation And Control<br>PI Detection BOT Detection<br>Business Rules</tooltip>
      </div>
      <div>
        <hotspot class="data-lake-hotspot"></hotspot>
        <tooltip class="yellow-tooltip data-lake-tooltip">Data Lake Comprising of RAW,<br>Transformed and Modified</tooltip>
      </div>
      <div>
        <hotspot class="enrich-hotspot"></hotspot>
        <tooltip class="white-tooltip enrich-tooltip">Enrich Your Data Create<br>Identities Manage Audiences<br>Secure Vault For PI</tooltip>
      </div>
      <div>
        <hotspot class="consumer-hotspot"></hotspot>
        <tooltip class="white-tooltip consumer-tooltip">Single Consumer, View All,<br>Touchpoints, Create Device ID,<br>Attribution Module, Churn Model</tooltip>
      </div>
      <div>
        <hotspot class="api-hotspot"></hotspot>
        <tooltip class="green-tooltip api-tooltip">API and<br>Generation Layer</tooltip>
      </div>
      <div>
        <hotspot class="activate optimization-hotspot"></hotspot>
        <tooltip class="blue-tooltip optimization-tooltip">Product Optimization Trough<br>Personal Experiences</tooltip>
      </div>
      <div>
        <hotspot class="activate marketing-hotspot"></hotspot>
        <tooltip class="blue-tooltip marketing-tooltip">Marketing Orchestration<br>Including Social Integration</tooltip>
      </div>
      <div>
        <hotspot class="activate reporting-hotspot"></hotspot>
        <tooltip class="blue-tooltip reporting-tooltip">Any Reporting, Dashboarding<br>and analytical tools - Tables,<br>Locker, Power</tooltip>
      </div>
      <div>
        <hotspot class="activate campaign-hotspot"></hotspot>
        <tooltip class="blue-tooltip campaign-tooltip">Campaign Management<br>Integrated to Any of your<br>Favorite ESP on the Market</tooltip>
      </div>
      <div>
        <hotspot class="activate decentralization-hotspot"></hotspot>
        <tooltip class="blue-tooltip decentralization-tooltip">Data&nbsp;Decentralization</tooltip>
      </div>
    </div>
    <start-now class="start-now"></start-now>
  </div>
</template>

<script>
  import Hotspot from './Hotspot.vue'
  import SchemeTooltip from './SchemeTooltip.vue'
  import StartNow from '../StartNow.vue'

  export default {
    name: 'BigDataScheme',
    data () {
      return {
        window: {
          width: 0
        }
      }
    },
    components: {
      'hotspot': Hotspot,
      'tooltip': SchemeTooltip,
      'start-now': StartNow
    },
    created () {
      window.addEventListener('resize', this.handleResize)
      this.handleResize()
    },
    destroyed () {
      window.removeEventListener('resize', this.handleResize)
    },
    methods: {
      handleResize () {
        this.window.width = window.innerWidth
      }
    }
  }
</script>

<style scoped>
  .big-data-scheme-wrapper {
    position: relative;
  }
  .big-data-scheme {
    margin-top: 40px;
    margin-bottom: 20px;
  }
  .tachyon-container .start-now {
    display: none;
    text-align: center;
  }
  .tachyon-container >>> .btn-start {
    padding: 14px 47px;
    margin-bottom: 50px;
  }
  .mobile-hotspot:hover + .mobile-tooltip,
  .iot-hotspot:hover + .iot-tooltip,
  .tracking-hotspot:hover + .tracking-tooltip,
  .any-format-hotspot:hover + .any-format-tooltip,
  .sensitize-hotspot:hover + .sensitize-tooltip,
  .scheme-hotspot:hover + .scheme-tooltip,
  .data-lake-hotspot:hover + .data-lake-tooltip,
  .enrich-hotspot:hover + .enrich-tooltip,
  .consumer-hotspot:hover + .consumer-tooltip,
  .api-hotspot:hover + .api-tooltip,
  .optimization-hotspot:hover + .optimization-tooltip,
  .marketing-hotspot:hover + .marketing-tooltip,
  .reporting-hotspot:hover + .reporting-tooltip,
  .campaign-hotspot:hover + .campaign-tooltip,
  .decentralization-hotspot:hover + .decentralization-tooltip {
    visibility: visible;
    opacity: 1;
  }
  @media (min-width: 1200px) {
    .big-data-scheme {
      max-width: 1500px;
      margin-left: -170px;
    }
  }
  @media (max-width: 1400px) {
    .big-data-scheme-wrapper {
      width: 1170px;
    }
  }
  @media (max-width: 1199px) {
    .big-data-scheme-wrapper {
      width: 960px;
    }
    .big-data-scheme {
      max-width: 1200px;
      margin-left: -140px;
    }
  }
  @media (max-width: 991px) {
    .big-data-scheme-wrapper {
      width: 520px;
      margin-left: auto;
      margin-right: auto;
    }
    .big-data-scheme {
      max-width: 100%;
      margin-left: 0;
    }
    .tachyon-container .start-now {
      display: block;
    }
  }
  @media (max-width: 575px) {
    .big-data-scheme-wrapper {
      width: 320px;
    }
  }
  @media (max-width: 479px) {
    .tachyon-container {
      width: 100% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Features/BigDataScheme.vue